import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import { Typography } from '../styled'
import { BannerCard } from './styled'

function FeedbackCandidateBanner({ items }) {
  return (
    <BannerCard>
      <Row>
        {items.map((item) => (
          <Col sm={4} className="mb-2" key={item.label}>
            <Typography
              size="12px"
              className="d-block mb-1"
              style={{ color: 'rgba(255,255,255,0.65)' }}
            >
              {item.label}
            </Typography>
            <Typography size="15px" bold style={{ color: '#ffffff' }}>
              {item.val || 'N/A'}
            </Typography>
          </Col>
        ))}
      </Row>
    </BannerCard>
  )
}

FeedbackCandidateBanner.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      val: PropTypes.string,
    }),
  ),
}

export default FeedbackCandidateBanner
